var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web-text-view"},[_c('textarea',{ref:"input",attrs:{"readonly":!_vm.editable,"maxlength":_vm.maxLength},domProps:{"value":_vm.text},on:{"input":_vm.emit,"blur":function($event){return _vm.$emit('blur')},"focus":function($event){return _vm.$emit('focus')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }